<template>
  <TariffNotificationModal
      ref="modalRef"
      :title="`Пауза PRO заканчивается ${formattedDate}`"
      button-text="Оплатить PRO"
      secondary-button-text="Отменить подписку"
      :max-width="450"
      @buttonClick="emit('confirm')"
      @secondaryButtonClick="emit('secondary')"
      @hidden="emit('hidden')"
  >
    <template #default>
      <p class="pause-ending-soon-modal__text mb-2">
        Подписка будет автоматически возобновлена, а оплата спишется с привязанной карты.
      </p>
      <p class="pause-ending-soon-modal__text mb-2">
        Если вы не планируете пользоваться PRO, отмените подписку до окончания периода паузы.
      </p>
      <p class="pause-ending-soon-modal__text mb-2">
        После отмены подписки тариф PRO станет недоступен для подключения, останутся только актуальные тарифы и отдельные платные опции.
      </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const props = defineProps<{
    pauseEndsAt: string;
}>();

const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'secondary'): void;
    (e: 'hidden'): void;
}>();

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const formattedDate = computed(() => {
    const date = new Date(props.pauseEndsAt);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });
});

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.pause-ending-soon-modal__text {
    font-size: 14px;
}
</style>
